import config from '@/config';
import useCache from '@/hooks/useCache';
import useGoBack from '@/hooks/useGoBack';
import useStateHandler from '@/hooks/useStateHandler';
import UserService from '@/services/user.service';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';
import Loader from "@/shared-components/loader/Loader";
import Text from '@/shared-components/text/components/Text';

import ClaimArtwork from './claim-artwork';
import VirtualList from './virtual-list';

import './index.css';

export default function MyCollection() {
  const { state } = useStateHandler();
  const { loading, fetchData, setFetchData, loadMoreData } = useCache("my_collection", `${config.apis.api.url}/collection/${state.user_session._id}`, {
    injectToken: true,
    includeSearchQueries: { visibility: "all" }, 
    invalidateWhen: ["BUY_ARTWORK"]
  });
  const { cacheHandler } = useStateHandler();
  const goBackHandler = useGoBack("/profile");

  function onClaimArtwork(newArtwork) {
    setFetchData({
      totalDocs: fetchData.totalDocs + 1,
      data: [
        newArtwork,
        ...fetchData.data
      ]
    });

    cacheHandler.triggerAction("EDIT_COLLECTION");
  }

  function changeArtworkVisibility(productToChange, isPrivate) {
    const newProductData = {
      ...productToChange,
      product_metadata: {
        ...productToChange.product_metadata,
        is_private: isPrivate
      }
    };

    UserService.editProduct(newProductData);
    cacheHandler.triggerAction("EDIT_COLLECTION");
    setFetchData({
      ...fetchData,
      data: fetchData.data.map(product => {
        if(product.product_id === productToChange.product_id) {
          return newProductData;
        } else {
          return product;
        }
      })
    });
  }

  return (
    <>
      <div className={`my-collection-outter ${fetchData?.data?.length === 0 ? 'empty' : ''}`}>
        <div className="my-collection__header">
          <span className="my-collection__header-text font-size-large">
          My Collection
          </span>

          <GoBackButton className="go-back-button"  onClick={goBackHandler} />
        </div>
            
        <div className="my-collection__container">
          {
            loading ? 
              <Loader/>
              : 
              <>

                {
                  fetchData.data.length === 0 ? 
                    <Text className="settings-my-collection__text" medium>
                    Purchase an Original Artwork or Limited Edition to unlock your collection
                    </Text>
                    :
                    <VirtualList
                      items={fetchData}
                      onLoadMore={loadMoreData}
                      changeArtworkVisibility={changeArtworkVisibility}
                    />
                }
                <ClaimArtwork onClaimArtwork={onClaimArtwork}/>
              </>
          }
        </div>
      </div>
    </>
  );
}
